<template>
  <el-header class="header">

    <Menu class="menu" mode="horizontal" :theme="theme" active-name="1" style="z-index: 99999999"
      :style="'background:' + TopBackground">
      <span class="title1" v-text="$store.state.title"></span>
      <img @click="sideOn()" class="switch" :src="
        $store.state.switch
          ? require('@/assets/images/off.png')
          : require('@/assets/images/on.png')
      " alt="." title="侧边栏开关" />
      <!-- <MenuItem v-for="(item,index) in headList" :name="index" @click="routers(item.router)">
        <Icon :type="item.icon" />
        {{ item.name }}
      </MenuItem> -->


      <MenuItem name="1" @click="routers('/content/statistics')">
      <Icon type="ios-paper" />
      内容管理
      </MenuItem>
      <MenuItem name="2" v-if="$store.state.control == 1 || $store.state.wl_control"
        @click="routers('/logistics/dispensestics')">
      <Icon type="md-bus" />
      智能物流
      </MenuItem>
      <MenuItem name="3" @click="routers('/setting/password')">
      <Icon type="ios-construct" />
      综合设置
      </MenuItem>

      <!-- 头部右侧 -->
      <div class="head">
        <Dropdown>
          <a href="javascript:void(0)" style="color: white">
            {{ $store.state.UserName }}
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <template #list>
            <DropdownMenu>
              <DropdownItem @click="routers('/setting/password')">修改密码</DropdownItem>
              <DropdownItem @click="tuichu"><span style="color: red">退出登录</span></DropdownItem>
            </DropdownMenu>
          </template>
        </Dropdown>
        &nbsp;
      </div>

      <div class="All" @click="quanping">
        <img src="../../assets/images/whiteqp.png" title="全屏" />
      </div>
    </Menu>
  </el-header>
</template>

<script>
export default {
  data() {
    return {
      theme: "",
      TopBackground: "",
      headList: [
        {
          router: '/content/statistics',
          icon: 'ios-paper',
          name: '内容管理',
          condition: ''
        },
        {
          router: '/dispense/dealer',
          icon: 'md-bus',
          name: '标签分发',
          condition: 'ff_control'
        },
        {
          router: '/logistics/storaList',
          icon: 'md-bus',
          name: '智能物流',
          condition: 'wl_control'
        },
        {
          router: '/setting/password',
          icon: 'ios-construct',
          name: '综合设置',
          condition: ''
        },
      ]
    };
  },
  mounted() {
    // 获取主题
    this.theme = this.$store.state.TopTheme;
    // 获取主题背景颜色
    this.TopBackground = this.$store.state.TopBackgroundColor;
  },
  methods: {
    // 路由跳转
    routers(val) {
      this.sideOn(true);
      this.$router.push(val);
    },
    // 侧边栏开关
    sideOn(a) {
      if (a == null) {
        var value = !this.$store.state.switch;
        this.$store.commit("Uswitch", value);
      } else {
        this.$store.commit("Uswitch", a);
      }
    },
    // 切换全屏
    quanping() {
      let fullscreen = document.documentElement; // 需要全屏的元素
      // 最新写法
      const isFullScreen = document.fullscreenElement;

      if (isFullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      } else {
        if (fullscreen.requestFullscreen) {
          fullscreen.requestFullscreen();
        } else if (fullscreen.mozRequestFullScreen) {
          fullscreen.mozRequestFullScreen();
        } else if (fullscreen.webkitRequestFullscreen) {
          fullscreen.webkitRequestFullscreen();
        } else if (fullscreen.msRequestFullscreen) {
          fullscreen.msRequestFullscreen();
        }
      }
    },
    tuichu() {
      sessionStorage.removeItem("JigGyrBuasd");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
@import url("//unpkg.com/element-ui@2.15.6/lib/theme-chalk/index.css");

.el-header {
  padding: 0%;
}

.title1 {
  display: block;
  width: 200px;
  color: white;
  font-weight: bold;
  line-height: 60px;
  font-size: 20px;
  text-align: center;
  height: 60px;
  float: left;
}

.header {
  background: #fff;
  z-index: 999;
}

.head {
  height: 60px;
  float: right;
  display: flex;
  flex-direction: row;
  margin-left: 20px;
  margin-right: 20px;
}

.head>.headImg {
  height: 40px;
  width: 40px;
  margin-top: 10px;
}

.head>.Uname {
  color: white;
  height: 60px;
  line-height: 60px;
  margin-left: 10px;
  transition: all 0.3s;
}

.switch {
  width: 24px;
  display: block;
  cursor: pointer;
  float: left;
  margin-top: 18px;
  margin-left: 15px;
}

.All {
  float: right;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}

.All>img {
  margin-top: 15px;
  width: 30px;
}

.esc {
  margin-left: 10px;
  float: right;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}

.esc>img {
  margin-top: 17px;
  width: 27px;
}
</style>
